// extracted by mini-css-extract-plugin
module.exports = {"link":"LanguageSwitcher-LanguageSwitcher-link-9d30d6e7","language":"LanguageSwitcher-LanguageSwitcher-language-a4801040"};